// src/components/SEO.jsx
import React from "react";
import { Helmet } from "react-helmet";

const SEO = ({
  title,
  description,
  keywords,
  image,
  url,
  canonical,
  type = "website",
  structuredData = null,
  noIndex = false,
  noFollow = false,
}) => {
  const defaultTitle =
    "Développeur freelance web, mobile et logiciel sur mesure | DigiBuddy";
  const defaultDescription =
    "DigiBuddy accompagne indépendants, TPE et PME : site web sur mesure, application mobile et logiciel métier. Méthode claire, livrables concrets.";
  const defaultKeywords =
    "développeur freelance, développeur web freelance, création site internet sur mesure, développement application mobile, logiciel métier sur mesure, refonte site web, maintenance site web";
  const defaultImage = "https://www.digibuddy.fr/cover.jpg";
  const defaultUrl = "https://www.digibuddy.fr";

  const finalTitle = title || defaultTitle;
  const finalDescription = description || defaultDescription;
  const finalKeywords = keywords || defaultKeywords;
  const finalImage = image || defaultImage;
  const finalUrl = url || defaultUrl;
  const canonicalUrl = canonical || finalUrl;

  return (
    <Helmet>
      {/* Meta tags de base */}
      <title>{finalTitle}</title>
      <meta name="description" content={finalDescription} />
      <meta name="keywords" content={finalKeywords} />
      {(noIndex || noFollow) && (
        <meta
          name="robots"
          content={`${noIndex ? "noindex" : "index"},${noFollow ? "nofollow" : "follow"}`}
        />
      )}

      {/* Open Graph */}
      <meta property="og:title" content={finalTitle} />
      <meta property="og:description" content={finalDescription} />
      <meta property="og:image" content={finalImage} />
      <meta property="og:url" content={finalUrl} />
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content="DigiBuddy" />
      <meta property="og:locale" content="fr_FR" />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={finalTitle} />
      <meta name="twitter:description" content={finalDescription} />
      <meta name="twitter:image" content={finalImage} />
      <meta name="twitter:site" content="@digibuddy" />
      <meta name="twitter:creator" content="@digibuddy" />

      {/* Canonical */}
      <link rel="canonical" href={canonicalUrl} />

      {/* Structured Data (objet unique ou tableau) */}
      {structuredData &&
        (Array.isArray(structuredData) ? structuredData : [structuredData]).map(
          (item, i) => (
            <script key={i} type="application/ld+json">
              {JSON.stringify(item)}
            </script>
          ),
        )}
    </Helmet>
  );
};

export default SEO;
